import { render, staticRenderFns } from "./newTool.vue?vue&type=template&id=60d142a6&scoped=true"
import script from "./newTool.vue?vue&type=script&lang=js"
export * from "./newTool.vue?vue&type=script&lang=js"
import style0 from "./newTool.vue?vue&type=style&index=0&id=60d142a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d142a6",
  null
  
)

export default component.exports